import './subheader.scss';
import React, { PropsWithChildren } from 'react';

import { ClbBreadcrumb } from '@celebration/react/ClbBreadcrumb/ClbBreadcrumb';
import { BreadcrumbItem } from '@celebration/react/ClbBreadcrumb/ClbBreadcrumb.types';

export interface SubheaderProps {
    title: string;
    breadcrumbList: BreadcrumbItem[];
    dataTestid?: string;
}

function SubheaderComponent({
    children,
    title,
    breadcrumbList,
    dataTestid,
}: PropsWithChildren<SubheaderProps>) {
    return (
        <div className="subheader" data-testid={dataTestid}>
            <div className="subheader-info" data-testid="subheader-info">
                <ClbBreadcrumb items={breadcrumbList} />
                <h1 className="subheader-title">{title}</h1>
            </div>
            {children && (
                <div
                    className="subheader-children"
                    data-testid="subheader-children"
                >
                    {children}
                </div>
            )}
        </div>
    );
}

export default SubheaderComponent;
